/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerfontneedstexthint4Inputs */

const en_flyerfontneedstexthint4 = /** @type {(inputs: Flyerfontneedstexthint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The typeface only applies once a title or description is set.`)
};

const de_flyerfontneedstexthint4 = /** @type {(inputs: Flyerfontneedstexthint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Schriftart wirkt erst, wenn Titel oder Beschreibung gefüllt sind.`)
};

/**
* | output |
* | --- |
* | "The typeface only applies once a title or description is set." |
*
* @param {Flyerfontneedstexthint4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerfontneedstexthint4 = /** @type {((inputs?: Flyerfontneedstexthint4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerfontneedstexthint4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerfontneedstexthint4(inputs)
	return de_flyerfontneedstexthint4(inputs)
});
export { flyerfontneedstexthint4 as "flyerFontNeedsTextHint" }